import GetSurveysDataStore from '../../datastores/GetSurveysDataStore';

const data = {
  surveys: {
    pendingSurveys: 10,
    hasRequired: true,
    blockedDate: '24/12/24',
    daysToBlock: 2
  }
};

export default class GetSurveysDataStoreMock implements GetSurveysDataStore {
  getSurveysValidation() {
    return data.surveys;
  }
}
